const RegExp = {
    specialCharacter:"^[\u4E00-\u9FA5A-Za-z0-9]+$",
    fileName: /^[^#%&*\/|:<>?\"]*$/,
    positiveInteger:/^([0]|[1-9][0-9]*)$/,
    Integer:/^([1-9][0-9]*)$/,
    Float:　/^([1-9][\d]*|0)(\.[\d]+)?$/,
}

export default RegExp